/**
 * Entry de la página `/galeria.html` — Fase 10d.
 *
 * Galería pública de screenshots del 51. Visitantes sin sesión la ven
 * (allowAnonymous); pilotos autenticados pueden subir; autor o admin+
 * pueden borrar.
 */

import { mountGaleria } from './modules/galeria/index.js';

void mountGaleria();
